export default __webpack_public_path__ + "static/media/download2.156d638e.svg";